// extracted by mini-css-extract-plugin
module.exports = {"FloatingInput":"FloatingInput_FloatingInput__2PEwn","Input":"FloatingInput_Input__3Acpv","Label":"FloatingInput_Label__1NRgi"};